import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=dd73628a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=dd73628a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd73628a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd73628a')) {
      api.createRecord('dd73628a', component.options)
    } else {
      api.reload('dd73628a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=dd73628a&scoped=true&", function () {
      api.rerender('dd73628a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8kLsG0xsWzD89/JS/comp/SearchFilterTokens.vue"
export default component.exports